/* FemmoraFit preview — hero reveal, mobile nav, checkout flow (payment mocked) */
(function () {
  "use strict";

  /* ---------- hero reveal ---------- */
  window.addEventListener("load", function () {
    document.querySelectorAll(".reveal").forEach(function (el, i) {
      setTimeout(function () { el.classList.add("in"); }, 80 + i * 20);
    });
  });

  /* ---------- mobile menu ---------- */
  var toggle = document.querySelector(".nav-toggle");
  var mobileMenu = document.getElementById("mobile-menu");
  function setMenu(open) {
    if (!mobileMenu || !toggle) return;
    mobileMenu.classList.toggle("is-open", open);
    if (open) { mobileMenu.hidden = false; } else { mobileMenu.hidden = true; }
    toggle.setAttribute("aria-expanded", open ? "true" : "false");
    toggle.setAttribute("aria-label", open ? "Menu sluiten" : "Menu openen");
  }
  if (toggle) {
    toggle.addEventListener("click", function () {
      setMenu(toggle.getAttribute("aria-expanded") !== "true");
    });
  }
  document.querySelectorAll("[data-mclose]").forEach(function (el) {
    el.addEventListener("click", function () { setMenu(false); });
  });

  /* ---------- pricing stagger reveal (one moment) ---------- */
  var grid = document.querySelector(".prijzen-grid");
  if (grid && "IntersectionObserver" in window &&
      !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    grid.classList.add("reveal-stagger");
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
      });
    }, { threshold: 0.2 });
    io.observe(grid);
  }

  /* ---------- scroll reveal ---------- */
  (function () {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    if (!("IntersectionObserver" in window)) return;
    var groups = [
      { sel: ".over-lead, .over-body" },
      { sel: ".aanbod-head, .aanbod-item", stagger: true },
      { sel: ".showcase-inner" },
      { sel: ".rooster-head, .slot", stagger: true },
      { sel: ".prijzen-head" },
      { sel: ".faq-head, .faq-item", stagger: true },
      { sel: ".contact-info, .contact-form" },
      { sel: ".footer-brand, .footer-col", stagger: true }
    ];
    var ro = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("is-visible"); ro.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    groups.forEach(function (g) {
      var els = document.querySelectorAll(g.sel);
      els.forEach(function (el, i) {
        el.classList.add("reveal-up");
        if (g.stagger) el.style.transitionDelay = Math.min(i * 70, 350) + "ms";
        ro.observe(el);
      });
    });
  })();

  /* ---------- collapsible footer (mobile / tablet) ---------- */
  (function () {
    var cols = document.querySelectorAll(".footer-col");
    var mq = window.matchMedia("(max-width: 900px)");
    cols.forEach(function (col) {
      var head = col.querySelector(".footer-col-head");
      if (!head) return;
      head.addEventListener("click", function () {
        if (!mq.matches) return;
        var open = col.classList.toggle("open");
        head.setAttribute("aria-expanded", open ? "true" : "false");
      });
    });
    function sync() {
      cols.forEach(function (col) {
        var head = col.querySelector(".footer-col-head");
        if (!mq.matches) { col.classList.remove("open"); if (head) head.setAttribute("aria-expanded", "true"); }
        else if (head) head.setAttribute("aria-expanded", col.classList.contains("open") ? "true" : "false");
      });
    }
    (mq.addEventListener ? mq.addEventListener("change", sync) : mq.addListener(sync));
    sync();
  })();

  /* ---------- dynamic count-up numbers ---------- */
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  function countUp(el) {
    var target = parseFloat(el.getAttribute("data-count"));
    var suffix = el.getAttribute("data-suffix") || "";
    if (isNaN(target)) return;
    if (reduce) { el.textContent = target + suffix; return; }
    var start = null, dur = 1400;
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * eased) + suffix;
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = target + suffix;
    }
    requestAnimationFrame(step);
  }
  var counters = document.querySelectorAll("[data-count]");
  if (counters.length && "IntersectionObserver" in window) {
    var cObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { countUp(e.target); cObs.unobserve(e.target); }
      });
    }, { threshold: 0.5 });
    counters.forEach(function (c) { cObs.observe(c); });
  } else {
    counters.forEach(function (c) { c.textContent = c.getAttribute("data-count") + (c.getAttribute("data-suffix") || ""); });
  }

  /* ---------- lead magnet (download program for email) ---------- */
  (function () {
    var form = document.querySelector(".lm-form");
    if (!form) return;
    var input = form.querySelector('input[type="email"]');
    var msg = form.querySelector(".lm-msg");
    var btn = form.querySelector("button");
    var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var email = (input.value || "").trim();
      if (!re.test(email)) {
        msg.textContent = "Vul een geldig e-mailadres in.";
        msg.className = "lm-msg err";
        input.focus();
        return;
      }
      btn.disabled = true;
      var original = btn.innerHTML;
      btn.textContent = "Versturen…";
      /* SEAM: POST { email } to your email service (Mailchimp/Mollie/backend)
         and email the program PDF. Mocked here. */
      setTimeout(function () {
        msg.textContent = "Gelukt! We hebben het programma naar " + email + " gestuurd. Check je inbox.";
        msg.className = "lm-msg ok";
        form.reset();
        btn.disabled = false;
        btn.innerHTML = original;
      }, 900);
    });
  })();

  /* ---------- showcase slideshow ---------- */
  (function () {
    var showcase = document.querySelector(".showcase");
    if (!showcase) return;
    var slides = showcase.querySelectorAll(".slide");
    var dots = showcase.querySelectorAll(".slide-dot");
    if (slides.length < 2) return;
    var idx = 0, timer = null, DELAY = 5000;
    function go(n) {
      idx = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle("is-active", i === idx); });
      dots.forEach(function (d, i) { d.classList.toggle("is-active", i === idx); });
    }
    function next() { go(idx + 1); }
    function prev() { go(idx - 1); }
    function start() { stop(); timer = setInterval(next, DELAY); }
    function stop() { if (timer) clearInterval(timer); }
    showcase.querySelector(".slide-next").addEventListener("click", function () { next(); start(); });
    showcase.querySelector(".slide-prev").addEventListener("click", function () { prev(); start(); });
    dots.forEach(function (d) {
      d.addEventListener("click", function () { go(parseInt(d.getAttribute("data-slide"), 10)); start(); });
    });
    showcase.addEventListener("mouseenter", stop);
    showcase.addEventListener("mouseleave", start);
    start();
  })();

  /* ---------- signup modal: collect IBAN + SEPA mandate, then real iDEAL checkout ---------- */
  var checkout = document.getElementById("checkout");
  if (checkout) {
    var variantInput = checkout.querySelector("#signup-variant");
    var planEls = checkout.querySelectorAll("[data-signup-plan]");
    var priceEls = checkout.querySelectorAll("[data-signup-price]");

    function openSignup(variant, plan, price) {
      if (variant && variantInput) variantInput.value = variant;
      planEls.forEach(function (el) { el.textContent = plan || ""; });
      priceEls.forEach(function (el) { el.textContent = price ? ("€" + price) : ""; });
      checkout.classList.add("is-open");
      checkout.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
      document.body.classList.add("checkout-open");
    }
    function closeSignup() {
      checkout.classList.remove("is-open");
      checkout.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
      document.body.classList.remove("checkout-open");
    }

    document.querySelectorAll("[data-signup]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        openSignup(btn.getAttribute("data-variant"), btn.getAttribute("data-plan"), btn.getAttribute("data-price"));
      });
    });
    document.querySelectorAll("[data-close-checkout]").forEach(function (btn) {
      btn.addEventListener("click", closeSignup);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && checkout.classList.contains("is-open")) closeSignup();
    });
  }
})();

/* ===================== POLISH: scroll progress, to-top, today ===================== */
(function () {
  "use strict";
  var bar = document.getElementById("scrollProgress");
  var toTop = document.getElementById("toTop");

  function onScroll() {
    var h = document.documentElement;
    var max = h.scrollHeight - h.clientHeight;
    var y = window.scrollY || h.scrollTop;
    if (bar) bar.style.width = (max > 0 ? (y / max) * 100 : 0) + "%";
    if (toTop) {
      if (y > 600) { toTop.hidden = false; toTop.classList.add("is-visible"); }
      else { toTop.classList.remove("is-visible"); }
    }
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  if (toTop) {
    toTop.addEventListener("click", function () {
      var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      window.scrollTo({ top: 0, behavior: reduce ? "auto" : "smooth" });
    });
  }

  /* rooster: highlight today's weekday card */
  var slots = document.querySelectorAll(".rooster-grid .slot .slot-day");
  if (slots.length) {
    var days = ["Zondag", "Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrijdag", "Zaterdag"];
    var today = days[new Date().getDay()];
    slots.forEach(function (el) {
      if (el.textContent.trim().toLowerCase() === today.toLowerCase()) {
        var card = el.closest(".slot");
        if (card) card.classList.add("is-today");
      }
    });
  }

  /* showcase: basic touch swipe */
  var showcase = document.querySelector(".showcase");
  if (showcase) {
    var x0 = null;
    showcase.addEventListener("touchstart", function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    showcase.addEventListener("touchend", function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 50) {
        var sel = dx < 0 ? ".slide-next" : ".slide-prev";
        var btn = showcase.querySelector(sel);
        if (btn) btn.click();
      }
      x0 = null;
    }, { passive: true });
  }
})();
